/*
  Free gift promo (no app). Configured in Theme settings > Free gift promo.
  - Reads cart total from /cart.js (gift products are NOT counted toward the minimum)
  - Draws a progress bar in: UpCart drawer, native drawer, cart page, gift collection page
  - When unlocked, shows a Claim button + pop-up to choose product and size
  - Gift line is tagged with the hidden property _free_gift; the price itself is made $0 by
    the automatic Shopify discount (Buy X Get Y), never by this script.
*/
(function () {
  'use strict';

  var dataEl = document.getElementById('FreeGiftData');
  var modal = document.getElementById('FreeGiftModal');
  if (!dataEl || !modal) return;

  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var PROP = '_free_gift';
  var SESSION_KEY = 'fgAutoOpened';
  var giftIds = {};
  D.products.forEach(function (p) { giftIds[p.id] = true; });

  var grid = modal.querySelector('[data-fg-grid]');
  var errorEl = modal.querySelector('[data-fg-error]');
  var addBtn = modal.querySelector('[data-fg-add]');
  var closeBtn = modal.querySelector('.fg-modal__close');

  var state = { cart: null, analysis: null, unlocked: false, claimed: false };
  var selection = { pid: null, vid: null };
  var freshAvailability = {}; // variant id -> boolean (from /products/handle.js)
  var saleCache = {};         // product handle -> { variantId: true/false } (true = on compare-at sale)
  var syncing = false, again = false, pendingAction = false, timer = null;
  var lastFocus = null;

  /* ---------------- helpers ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (whole ? cents / 100 : (cents / 100).toFixed(2));
    }
  }

  function tpl(text, remaining) {
    return esc(text)
      .replace(/\{amount\}/g, '<strong>' + money(D.threshold) + '</strong>')
      .replace(/\{remaining\}/g, '<strong>' + money(Math.max(remaining || 0, 0)) + '</strong>');
  }

  var rawFetch = window.fetch; // captured before we wrap it

  function getCart() {
    return rawFetch.call(window, '/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function toast(msg) {
    var old = document.querySelector('.fg-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'fg-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 3800);
  }

  /* ---------------- cart analysis + rules ---------------- */
  function isSaleLine(it) {
    if (!D.excludeSale) return false;
    if (it.line_level_total_discount > 0) return true;       // already discounted by an automatic discount
    var info = saleCache[it.handle];
    if (info === undefined) return false;
    if (info === null) return true;                           // lookup failed: be conservative, do not count
    return !!info[it.variant_id];
  }

  function analyze(cart) {
    var a = { eligible: 0, excluded: 0, gift: [], flagged: [] };
    cart.items.forEach(function (it) {
      if (giftIds[it.product_id]) {
        a.gift.push(it);
        if (it.properties && it.properties[PROP]) a.flagged.push(it);
      } else if (isSaleLine(it)) {
        a.excluded += it.final_line_price;
      } else {
        a.eligible += it.final_line_price;
      }
    });
    return a;
  }

  // Looks up compare-at prices once per product (cached) so sale items can be left out of the minimum
  function loadSaleInfo(cart) {
    if (!D.excludeSale) return Promise.resolve();
    var todo = [];
    cart.items.forEach(function (it) {
      if (!giftIds[it.product_id] && saleCache[it.handle] === undefined && todo.indexOf(it.handle) === -1) todo.push(it.handle);
    });
    return Promise.all(todo.map(function (h) {
      return rawFetch.call(window, '/products/' + h + '.js', { cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
        .then(function (j) {
          var m = {};
          j.variants.forEach(function (v) { m[v.id] = !!(v.compare_at_price && v.compare_at_price > v.price); });
          saleCache[h] = m;
        })
        .catch(function () { saleCache[h] = null; });
    }));
  }

  function changeLine(key, qty) {
    return window.fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function sync(cart, fromAction) {
    var a = analyze(cart);
    var unlocked = a.eligible >= D.threshold;
    var ops = [];

    if (a.flagged.length) {
      if (!unlocked) {
        a.flagged.forEach(function (f) { ops.push([f.key, 0]); });
      } else {
        a.flagged.forEach(function (f, i) {
          if (i > 0) ops.push([f.key, 0]);      // keep only the newest claimed gift line
          else if (f.quantity > 1) ops.push([f.key, 1]); // max 1 per order
        });
      }
    }

    if (ops.length) {
      var removedForSpend = !unlocked;
      var chain = Promise.resolve();
      ops.forEach(function (op) { chain = chain.then(function () { return changeLine(op[0], op[1]); }); });
      return chain.then(function () {
        if (removedForSpend) toast('Free gift removed. Your cart is below ' + money(D.threshold) + '.');
        again = true;
      });
    }

    state.cart = cart;
    state.analysis = a;
    state.unlocked = unlocked;
    state.claimed = a.flagged.length > 0 || (a.gift.length > 0 && unlocked);

    mountAll();
    renderAll();

    // Auto-open once per session, only right after the shopper changed the cart
    if (fromAction && unlocked && !state.claimed && D.autoOpen && !isOpen()) {
      var seen = false;
      try { seen = sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) {}
      if (!seen) {
        try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
        setTimeout(function () { if (state.unlocked && !state.claimed) openModal(); }, 450);
      }
    }
  }

  function refresh() {
    if (syncing) { again = true; return Promise.resolve(); }
    syncing = true;
    var act = pendingAction;
    pendingAction = false;
    return getCart()
      .then(function (cart) { return loadSaleInfo(cart).then(function () { return sync(cart, act); }); })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (again) { again = false; schedule(false); }
      });
  }

  function schedule(fromAction) {
    if (fromAction) pendingAction = true;
    clearTimeout(timer);
    timer = setTimeout(refresh, 180);
  }

  /* ---------------- progress bar ---------------- */
  function barHTML() {
    var a = state.analysis;
    if (!a) return '';
    var th = D.threshold, ship = D.shippingThreshold || 0;
    var cartTotal = state.cart.total_price;               // free shipping counts the whole cart
    var merged = ship > 0 && ship === th;                 // both rewards unlock at the same amount
    var shipDone = ship > 0 && cartTotal >= ship;
    var pct = Math.max(0, Math.min(100, (a.eligible / th) * 100));
    var msg, action = '';
    var cls = 'fg-bar';

    if (state.claimed) {
      cls += ' is-claimed is-unlocked';
      msg = tpl(D.text.claimed);
      if (a.flagged.length) action = '<button type="button" class="fg-link" data-fg-open>Change</button>';
    } else if (state.unlocked) {
      cls += ' is-unlocked';
      msg = tpl(merged ? 'You unlocked FREE shipping + a FREE lounge set!' : D.text.unlocked);
      action = '<button type="button" class="fg-btn fg-btn--small" data-fg-open>' + esc(D.text.claim) + '</button>';
    } else if (merged && shipDone) {
      // whole cart reached the amount, but sale items don't count toward the free set
      msg = tpl('FREE shipping unlocked! {remaining} more in full-price items for a FREE lounge set', th - a.eligible);
    } else if (merged) {
      msg = tpl("You're {remaining} away from FREE shipping + a FREE lounge set", th - a.eligible);
    } else if (ship > 0 && ship < th && cartTotal < ship) {
      msg = tpl(D.text.shipping, ship - cartTotal);
    } else {
      msg = tpl(D.text.progress, th - a.eligible);
    }

    var legend = merged
      ? '<span></span><span>Free shipping + free set ' + money(th) + '</span>'
      : (ship > 0 && ship < th)
        ? '<span>Free shipping ' + money(ship) + '</span><span>Free set ' + money(th) + '</span>'
        : '<span></span><span>Free set ' + money(th) + '</span>';

    return '<div data-fg-cls="' + cls + '">' +
      '<div class="fg-bar__row"><span class="fg-bar__msg">' + msg + '</span>' + action + '</div>' +
      '<div class="fg-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="' + th +
        '" aria-valuenow="' + Math.min(a.eligible, th) + '"><span class="fg-bar__fill" style="width:' + pct.toFixed(1) + '%"></span></div>' +
      '<div class="fg-bar__legend">' + legend + '</div>' +
      (D.excludeSale && D.text.note ? '<div class="fg-bar__note">' + esc(D.text.note) +
        (a.excluded > 0 ? ' (' + money(a.excluded) + ' in your cart)' : '') + '</div>' : '') + '</div>';
  }

  function paint(el, html) {
    var m = html.match(/data-fg-cls="([^"]*)"/);
    var base = el.className.replace(/\bis-(claimed|unlocked)\b/g, '').replace(/\s+/g, ' ').trim();
    el.className = base + (m ? ' ' + m[1].replace(/\bfg-bar\b/, '').trim() : '');
    if (el.__fgHtml !== html) { el.innerHTML = html; el.__fgHtml = html; }
  }

  function renderAll() {
    var html = barHTML();
    if (!html) return;
    document.querySelectorAll('[data-fg-bar]').forEach(function (el) { paint(el, html); });
    var sr = upcartRoot();
    if (sr) sr.querySelectorAll('[data-fg-bar]').forEach(function (el) { paint(el, html); });
  }

  /* ---------------- mounting points ---------------- */
  function makeBar(extra) {
    var d = document.createElement('div');
    d.className = 'fg-bar ' + (extra || '');
    d.setAttribute('data-fg-bar', '');
    return d;
  }

  function mountAll() {
    // Cart page
    var pageForm = document.getElementById('CartPageForm');
    if (pageForm && !pageForm.querySelector('[data-fg-bar]')) {
      var pageCols = pageForm.querySelector('.cart__page');
      if (pageCols) pageForm.insertBefore(makeBar('fg-bar--page'), pageCols);
    }
    // Native theme drawer (fallback if UpCart is ever turned off)
    var drawerInner = document.querySelector('#CartDrawerForm .drawer__inner');
    if (drawerInner && !drawerInner.querySelector('[data-fg-bar]')) {
      drawerInner.insertBefore(makeBar('fg-bar--drawer'), drawerInner.firstChild);
    }
    // Gift collection page
    if (D.showCollectionBanner && location.pathname.indexOf('/collections/' + D.collectionHandle) === 0 &&
        !document.querySelector('[data-fg-bar].fg-bar--banner')) {
      var anchor = document.querySelector('.collection-content');
      var host = document.getElementById('MainContent');
      var bar = makeBar('fg-bar--banner');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(bar, anchor);
      else if (host) host.insertBefore(bar, host.firstChild);
    }
    mountUpcart();
  }

  function upcartRoot() {
    var h = document.getElementById('upCart');
    return (h && h.shadowRoot) || null;
  }

  function mountUpcart() {
    var sr = upcartRoot();
    if (!sr) return false;
    var body = sr.querySelector('.upcart-cart-body');
    if (!body) return false;
    var created = false;

    if (!sr.querySelector('[data-fg-style]')) {
      var st = document.createElement('style');
      st.setAttribute('data-fg-style', '');
      st.textContent = document.getElementById('FreeGiftCss').textContent +
        '.fg-bar--upcart{margin:10px 16px 12px;width:auto;}' +
        (D.hideUpcartRewards ? '.upcart-public-rewards,.upcart-internal-rewards{display:none!important;}' : '');
      sr.appendChild(st);
    }
    if (!sr.querySelector('[data-fg-bar]')) {
      var bar = makeBar('fg-bar--upcart');
      var items = body.querySelector('.upcart-public-cart-items');
      if (items) body.insertBefore(bar, items); else body.insertBefore(bar, body.firstChild);
      created = true;
    }
    return created;
  }

  var upcartObserver = null;
  function watchUpcart() {
    var sr = upcartRoot();
    if (!sr || upcartObserver) return;
    var t;
    upcartObserver = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (mountUpcart() && state.analysis) renderAll();
      }, 60);
    });
    upcartObserver.observe(sr, { childList: true, subtree: true });
    if (mountUpcart() && state.analysis) renderAll();
  }

  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    watchUpcart();
    if (upcartObserver || tries > 80) clearInterval(poll);
  }, 500);

  /* ---------------- pop-up ---------------- */
  function isOpen() { return modal.classList.contains('is-open'); }

  function isAvailable(v) {
    return Object.prototype.hasOwnProperty.call(freshAvailability, v.id) ? freshAvailability[v.id] : v.available;
  }

  function renderGrid() {
    var html = '';
    D.products.forEach(function (p) {
      var avail = p.variants.filter(isAvailable);
      if (!avail.length) return; // sold out everywhere: hide
      var single = p.variants.length === 1 && /default title/i.test(p.variants[0].title);
      var sel = selection.pid === p.id;
      html += '<div class="fg-card' + (sel ? ' is-selected' : '') + '" data-pid="' + p.id + '">' +
        '<button type="button" class="fg-card__pick" data-fg-pick="' + p.id + '" aria-pressed="' + sel + '">' +
          (p.image ? '<img class="fg-card__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<span class="fg-card__img"></span>') +
          '<span class="fg-card__title">' + esc(p.title) + '</span>' +
          '<span class="fg-card__price"><s>' + money(p.price) + '</s> <b>FREE</b></span>' +
        '</button>';
      if (!single) {
        html += '<div class="fg-sizes" role="group" aria-label="Size">';
        p.variants.forEach(function (v) {
          var ok = isAvailable(v);
          var on = selection.vid === v.id;
          html += '<button type="button" class="fg-size' + (on ? ' is-selected' : '') + '" data-fg-size="' + v.id +
            '" data-pid="' + p.id + '"' + (ok ? '' : ' disabled') + ' aria-pressed="' + on + '">' + esc(v.title) + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    grid.innerHTML = html || '<p>All free sets are claimed right now. Check back soon!</p>';
    addBtn.disabled = !selection.vid;
  }

  function product(pid) {
    for (var i = 0; i < D.products.length; i++) if (D.products[i].id === pid) return D.products[i];
    return null;
  }

  function pickProduct(pid) {
    var p = product(pid);
    if (!p) return;
    if (selection.pid !== pid) { selection.pid = pid; selection.vid = null; }
    var avail = p.variants.filter(isAvailable);
    if (avail.length === 1) selection.vid = avail[0].id; // nothing to choose
    errorEl.textContent = '';
    renderGrid();
  }

  function pickSize(vid, pid) {
    selection.pid = pid;
    selection.vid = vid;
    errorEl.textContent = '';
    renderGrid();
  }

  function refreshAvailability() {
    return Promise.all(D.products.map(function (p) {
      return rawFetch.call(window, '/products/' + p.handle + '.js', { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j) return;
          j.variants.forEach(function (v) { freshAvailability[v.id] = !!v.available; });
        }).catch(function () {});
    })).then(function () {
      var p = selection.pid && product(selection.pid);
      if (selection.vid && p) {
        var v = p.variants.filter(function (x) { return x.id === selection.vid; })[0];
        if (!v || !isAvailable(v)) selection.vid = null;
      }
      if (isOpen()) renderGrid();
    });
  }

  function openModal() {
    lastFocus = document.activeElement;
    document.body.appendChild(modal); // last in DOM so it sits above the UpCart drawer
    modal.hidden = false;
    modal.classList.add('is-open');
    document.documentElement.classList.add('fg-lock');
    errorEl.textContent = '';
    addBtn.textContent = 'Add free set to cart';
    renderGrid();
    refreshAvailability();
    setTimeout(function () { closeBtn.focus(); }, 30);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('fg-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function claim() {
    if (!selection.vid || addBtn.disabled) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    errorEl.textContent = '';
    var props = {}; props[PROP] = '1';
    window.fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: selection.vid, quantity: 1, properties: props }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          errorEl.textContent = (res.j && (res.j.description || res.j.message)) || 'Sorry, that size just sold out. Please pick another.';
          addBtn.textContent = 'Add free set to cart';
          selection.vid = null;
          return refreshAvailability();
        }
        closeModal();
        toast('Free lounge set added!');
        selection = { pid: null, vid: null };
        try {
          if (typeof window.upcartOpenCart === 'function' && !document.body.classList.contains('upcartPopupShow') &&
              location.pathname.indexOf('/cart') !== 0) window.upcartOpenCart();
        } catch (e) {}
        schedule(false);
      })
      .catch(function () {
        errorEl.textContent = 'Something went wrong. Please try again.';
        addBtn.textContent = 'Add free set to cart';
        addBtn.disabled = !selection.vid;
      });
  }

  /* ---------------- events ---------------- */
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || !n.hasAttribute) continue;
      if (n.hasAttribute('data-fg-open')) { e.preventDefault(); openModal(); return; }
    }
  }, true);

  modal.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    if (t.closest('[data-fg-close]')) { closeModal(); return; }
    var pick = t.closest('[data-fg-pick]');
    if (pick) { pickProduct(Number(pick.getAttribute('data-fg-pick'))); return; }
    var size = t.closest('[data-fg-size]');
    if (size && !size.disabled) { pickSize(Number(size.getAttribute('data-fg-size')), Number(size.getAttribute('data-pid'))); return; }
    if (t.closest('[data-fg-add]')) claim();
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Tab') {
      var f = modal.querySelectorAll('button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- keep in sync with every cart change ---------------- */
  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var prevFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = prevFetch.apply(this, arguments);
    if (CART_URL.test(url)) p.then(function () { schedule(true); }, function () {});
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_URL.test(url)) {
      this.addEventListener('load', function () { schedule(true); });
    }
    return xhrOpen.apply(this, arguments);
  };

  document.addEventListener('cart:updated', function () { schedule(true); });
  document.addEventListener('cart:refresh', function () { schedule(true); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(false); });
  window.addEventListener('pageshow', function () { schedule(false); });

  // Re-sync whenever a drawer opens (UpCart sets a body class)
  new MutationObserver(function () {
    if (document.body.classList.contains('upcartPopupShow')) { watchUpcart(); schedule(false); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  schedule(false);
})();
